import Vue from 'vue';
import App from './App.vue';
import router from './router';
import '@mdi/font/css/materialdesignicons.css'
import vuetify from './plugins/vuetify';
import { refObjects } from '@/referenceArrays'
import '@/assets/styles/custom_variables.scss';
import '@/assets/styles/global_styles.scss'
import 'typeface-raleway';

Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  methods:{
    getPageReferences: () => { return refObjects}
  },
  render: h => h(App)
}).$mount('#app')